const searchStrip = {
  hotels: "Hôtels", // translated
  city: "Ville", // translated
  checkIn: "Enregistrement", // translated
  checkOut: "Vérifier", // translated
  date: "Date", // translated
  persons: "Personnes", // translated
  adults: "Adultes", // translated
  rooms: "Pièces", // translated
  editSearch: "Modifier la recherche", // translated
  newSearch: "Nouvelle recherche", // translated
  listView: "Affichage de liste", // translated
  mapView: "Vue de la carte", // translated
};


export default searchStrip;
